import { FC, Fragment } from 'react'
import { ApolloError } from '@apollo/client'
import { omitBy } from 'lodash'
import styled from 'styled-components'
import { ActivityOrderField, RecruitListQuery } from 'generated/graphql'
import useCheckQueryParamsForRecruitAds from '@app.feature/ad/hooks/useCheckQueryParamsForRecruitAds'
import NoticeBannerRecruitInternStatusMobile from '@app.feature/ad/mobile/NoticeBanner/RecruitIntern/NoticeBannerRecruitInternStatus.mobile'
import { ActivityTypeID } from 'constants/enums'
import RecruitListSkeleton from '../RecruitListSkeleton'
import RecruitListItemMobile from './component/RecruitListItem.mobile'

type TProps = {
  loading: boolean
  activityType: ActivityTypeID
  currentOrderByField: ActivityOrderField
  filters: ReturnType<typeof omitBy>
  data?: RecruitListQuery
  error?: ApolloError
}

const ListTableMobile: FC<TProps> = ({
  loading,
  data,
  error,
  filters,
  currentOrderByField,
  activityType,
}) => {
  const nodes = data?.activities?.nodes || []

  function renderList() {
    if (error) return null

    if (loading) {
      return <RecruitListSkeleton isMobile={true} />
    }

    if (nodes.length === 0) {
      return <div className="list-no-data">검색결과가 없습니다.</div>
    }

    return (
      <>
        {nodes.map((node) => (
          <Fragment key={node.id}>
            <RecruitListItemMobile
              activity={node}
              currentUser={data?.currentUser}
            />
          </Fragment>
        ))}
      </>
    )
  }

  const { isShowNoticeBanner } = useCheckQueryParamsForRecruitAds({
    filters,
    currentOrderByField,
    hasActivities: nodes.length > 0,
  })

  return (
    <StyledWrapper>
      <>
        {isShowNoticeBanner && (
          <NoticeBannerRecruitInternStatusMobile
            activityType={activityType}
            currentUser={data?.currentUser}
          />
        )}
        {renderList()}
      </>
    </StyledWrapper>
  )
}

export default ListTableMobile

const StyledWrapper = styled.div`
  background-color: #ffffff;

  .list-no-data {
    padding: 40px;
    text-align: center;
  }
`
